module.exports = "<div class=\"kt-portlet\" [ngClass]=\"class\" #refPortlet>\r\n\t<ng-content></ng-content>\r\n</div>\r\n"